export const RESOURCE = {
  ADMIN_LOGIN: 'adminLogin',
  CREATE_CONTRACT: 'createContract',
  GET_CONTRACT_LIST: 'getContractList',
  GET_USER_DATA: 'getUserData',
  GET_CONTRACT: 'getContract',
  SIGN_CONTRACT: 'signContract',
  NOT_SIGN_CONTRACT: 'notSignContract',
  DEMUR_CONTRACT: 'demurContract',
  GET_CONTRACT_DATA_FORM: 'getContractDataForm',
  UPDATE_CONTRACT_FORM_DATA: 'updateContractFormData',
  ADMIN_UPDATE_CONTRACT_FORM_DATA: 'adminUpdateContractFormData',
  GET_CONTRACT_PDF: 'getContractPdf',
  REJECT_OBJECTION: 'rejectObjection',
  SEND_NOTARISA: 'sendNotarisa',
  CANCEL_CONTRACT: 'cancelContract',
  GET_ASSETS: 'getAssets',
  SEARCH_CONTRACT: 'searchContract',
  SAVE_CONTRACT: 'saveContract',
  SAVE_PAYMENT: 'savePayment',
  UPDATE_PASSWORD: 'updatePassword',
  GET_COUPON_LIST: 'getCouponList',
  CREATE_COUPON: 'createCoupon',
  CONSUME_COUPON: 'consumeCoupon',
  VALIDATE_COUPON: 'validateCoupon',
  GET_MONITORING_DATA: 'getMonitoringData',
  RESEND_MAIL: 'resendMail',
  GET_JURIDICAL_CERT: 'getJuridicalCert',
  DOWNLOAD_EXCEL: 'downloadExcel',
  SAVE_NEW_CONTRACT_PDF: 'saveNewContractPdf',
  SAVE_DRAFT: 'saveDraft',
  GET_DRAFT: 'getDraft',
  LIST_NOTIFICATION_CONTRACT: 'listNotificationContract',
  GET_PREVIEW_PDF: 'GET_PREVIEW_PDF',
  GET_DOMAIN_CERT: 'GET_DOMAIN_CERT',
};

export const MESSAGE = {
  ERROR: {
    ADMIN_LOGIN: 'Ha ocurrido un error al intentar acceder.',
    CREATE_CONTRACT: 'Ha ocurrido un error al intentar crear documento',
    GET_CONTRACT_LIST: 'Ha ocurrido un error al intentar obtener lista de contratos',
    GET_USER_DATA: 'Ha ocurrido un error al intentar obtener la información del usuario',
    GET_CONTRACT: 'Ha ocurrido un error al intentar obtener información del contrato',
    SIGN_CONTRACT: 'Ha ocurrido un error al intentar firmar el contrato',
    NOT_SIGN_CONTRACT: 'Para continuar, debe dibujar su firma en el panel inferior utilizando su mause',
    DEMUR_CONTRACT: 'Ha ocurrido un error al intentar objetar el contrato',
    GET_CONTRACT_DATA_FORM: 'Ha ocurrido un error al intentar obtener información del contrato',
    UPDATE_CONTRACT_FORM_DATA: 'Ha ocurrido un error al intentar actualizar la información del contrato',
    ADMIN_UPDATE_CONTRACT_FORM_DATA: 'Ha ocurrido un error al intentar actualizar la información del contrato',
    GET_CONTRACT_PDF: 'Ha ocurrido un error al intentar obtener contrato PDF',
    REJECT_OBJECTION: 'Ha ocurrido un error al intentar rechazar la objeción del contrato',
    SEND_NOTARISA: 'Ha ocurrido un error al intentar enviar el contrato a Notarisa',
    CANCEL_CONTRACT: 'Ha ocurrido un error al intentar anular el contrato',
    GET_ASSETS: 'Ha ocurrido un error al intentar obtener imagenes de evidencias',
    SEARCH_CONTRACT: 'Ha ocurrido un error al intentar buscar el contrato',
    SAVE_CONTRACT: 'Ha ocurrido un error al proceder con la creación de tu contrato',
    SAVE_PAYMENT: 'Ha ocurrido un error al intentar guardar los datos de pago de su contrato',
    RESEND_MAIL: 'Ha ocurrido un problema al intentar reenviar el correo',
    UPDATE_PASSWORD: 'Ha ocurrido un problema al intentar actualizar tu contraseña',
    GET_COUPON_LIST: 'Ha ocurrido un problema al intentar obtener la lista de cupones.',
    CREATE_COUPON: 'Ha ocurrido un problema al intentar crear un nuevo código promocional',
    CONSUME_COUPON: 'Ha ocurrido un error al intentar utilizar el cupón',
    VALIDATE_COUPON: 'Ha ocurrido un error al intentar validar tu cupón',
    GET_JURIDICAL_CERT: 'Ha ocurrido un error al intentar obtener certificado',
    DOWNLOAD_EXCEL: 'Ha ocurrido un error al intentar descargar planilla excel',
    SAVE_NEW_CONTRACT_PDF: 'Ha ocurrido un error al intentar cargar el contrato',
    SAVE_DRAFT: 'Ha ocurrido un error al intentar guardar el borrador de su contrato',
    GET_DRAFT: 'Ha ocurrido un error al intentar obtener los datos guardados previamente',
    LIST_NOTIFICATION_CONTRACT: 'Ha ocurrido un error al intentar obtener notificaciones',
    GET_PREVIEW_PDF: 'Ha ocurrido un problema al intentar generar una vista previa del contrato',
    GET_DOMAIN_CERT: 'Ha ocurrido un problema al intentar obtener el certificado de dominio de la propiedad.',
    DEFAULT: 'Ha ocurrido un error inesperado'
  },
  SUCCESS: {
    REGISTER: 'Usuario creado correctamente. Puede iniciar sesión utilizando sus credenciales.',
    CHANGE_PASS: 'Contraseña cambiada satisfactoriamente.',
    LOGIN: 'Usuario pudo conectarse correctamente.',
    DEFAULT: 'Respuesta satisfactoria del servidor!',
  }
};
